import {
	LogoutOutlined,
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	UserOutlined,
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import React from 'react';

import classes from './Header.module.less';

import useAuth from 'hooks/useAuth';
import useLoading from 'hooks/useLoading';

const { Header: AntdHeader } = Layout;

type Props = {
	isSidebarCollapsed: boolean;
	onToggleSidebar: () => void;
};

const Header = ({ isSidebarCollapsed, onToggleSidebar }: Props) => {
	const auth = useAuth();
	const loading = useLoading();

	const logout = async () => {
		loading.enable();

		await auth.logout();
		loading.disable();
	};

	const menuItems: ItemType[] = [
		{
			key: '1',
			className: classes.sidebarToggler,
			icon: isSidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />,
			onClick: onToggleSidebar,
		},
		{
			key: '2',
			className: classes.profile,
			icon: <UserOutlined />,
			label: auth?.user?.getName(),
			children: [
				{
					key: '2.1',
					icon: <LogoutOutlined />,
					label: 'Выйти',
					onClick: logout,
				},
			],
		},
	];

	return (
		<AntdHeader className={classes.container}>
			<Menu mode="horizontal" selectable={false} className={classes.menu} items={menuItems} />
		</AntdHeader>
	);
};

export default Header;
